module.exports = __webpack_public_path__ + "static/media/success-tick.91e8326e.svg";